import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import janakLogo from "../assets/janak.png";

/* ===== THEME COLORS ===== */
const COLORS = {
  primary: "#3AAFA9",
  textMain: "#2E2E2E",
  textSub: "#4B5563",
  line: "#E6E8EC",
};

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { label: "Home", href: "/" },
    { label: "About", href: "/about" },
    { label: "Services", href: "/services" },
    { label: "How It Works", href: "/how-it-work" },
    { label: "Safety", href: "/safety" },
    { label: "Contact", href: "/contact" },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="site-header">
      {/* MAIN CONTAINER */}
      <div className="site-header-bar max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[88px] sm:h-[105px] md:h-[115px] grid grid-cols-[auto_1fr_auto] items-center gap-4 lg:gap-6">

        {/* LOGO */}
        <Link to="/" className="flex items-center gap-3 min-w-0">
          <span className="flex h-16 w-16 sm:h-20 sm:w-20 md:h-[86px] md:w-[86px] lg:h-[96px] lg:w-[96px] shrink-0 items-center justify-center transition-transform duration-200 hover:scale-105">
            <img
              src={janakLogo}
              alt="JANAK logo"
              className="h-full w-full object-contain"
            />
          </span>
        </Link>

        {/* DESKTOP NAV */}
        <nav className="site-header-nav hidden md:flex items-center justify-center gap-1 text-[15px] lg:text-base font-bold">
          {navItems.map((item) => (
            <Link
              key={item.href}
              to={item.href}
              className={`site-nav-link ${isActive(item.href) ? "site-nav-link-active" : ""}`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        {/* DESKTOP BUTTON */}
        <div className="hidden md:flex justify-end">
          <Link
            to="/subscription"
            className="site-subscription-btn px-6 lg:px-7 py-3 rounded-full text-sm lg:text-[15px] font-bold transition-all duration-300 active:scale-[0.97]"
            style={{
              backgroundColor: COLORS.primary,
              color: "#FFFFFF",
              boxShadow: "0 8px 22px rgba(58,175,169,0.32)",
            }}
          >
            Subscription
          </Link>
        </div>

        {/* MOBILE BUTTON */}
        <button
          className="justify-self-end md:hidden rounded-full bg-white p-2 shadow-sm ring-1 ring-[#E6E8EC]"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle Menu"
          style={{ color: COLORS.textMain }}
        >
          {menuOpen ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

     
{/* MOBILE MENU */}
<div
  className={`
    site-mobile-menu md:hidden absolute left-0 top-full w-full bg-white
    transition-all duration-300 ease-in-out
    ${menuOpen ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2 pointer-events-none"}
  `}
>
  <div className="flex flex-col text-[16px] font-semibold">

    {navItems.map((item) => (
      <Link
        key={item.href}
        to={item.href}
        onClick={() => setMenuOpen(false)}
        className="px-6 py-4 border-b"
        style={{
          borderColor: "#f1f1f1",
          color: isActive(item.href)
            ? COLORS.primary
            : COLORS.textSub,
        }}
      >
        {item.label}
      </Link>
    ))}

    {/* Subscription Button */}
    <div className="px-6 py-6">
      <Link
        to="/subscription"
        onClick={() => setMenuOpen(false)}
        className="block rounded-full text-center py-3 text-sm font-bold transition-all duration-200 active:scale-[0.98]"
        style={{
          backgroundColor: COLORS.primary,
          color: "#fff",
        }}
      >
        Subscription
      </Link>
    </div>

  </div>
</div>

    </header>
  );
};

export default Header;
